





















































































































































































































// vendor
import { defineComponent, computed, ref, set, PropType } from "@vue/composition-api";
import { DisplayJSON } from "@/components.generic/display-code";
import { Form } from "@/psychlab/types/form";

const icons = {
	"Answer":"mdi.card-text",
	"Checkboxes":"mdi.card-text",
	"MultipleChoice":"mdi.radiobox-marked",
	"Dropdown":"mdi.chevron-down-box",
	"LinearScale":"mdi.electric-switch-closed",
	"Information":"mdi.information-outline",
	"HTML":"mdi.code-tags",
};

export default defineComponent({

	emits:[],
	props:{
		data:{
			type:Object as PropType<Form>,
			required:true,
		}
	},
	components:{
		"display-json":DisplayJSON
	},
	setup(props){

		const foldouts = ref<{ [k:string]:boolean }>({});


		const showSettings = computed(() => {
			
			const f = props.data;
			if(!props.data || !props.data.settings){ return false; }
			return Boolean(getSectionShuffleTooltip(props.data.settings.sectionSelection));

		});

		const getShuffleIcon = (m:string) => {
			return (({
				"shuffle":"mdi.shuffle",
				"select":"mdi.numeric-1-box"
			} as any)[m] || "mdi.shuffle-disabled");
		};

		const getItemShuffleTooltip = (m:string) => {
			return (({
				"shuffle":"Shuffle items",
				"select":"Select one item"
			} as any)[m] || "");
		};

		const getSectionShuffleTooltip = (m:string) => {
			return (({
				"shuffle":"Shuffle section",
				"select":"Select one section"
			} as any)[m] || "");
		};

		const toggleFoldout = (k:string) => {
			set(foldouts.value, k, !Boolean(foldouts.value[k]));
		};

		const isEmptyObject = (ob:any) => {
			return Object.keys(ob).length === 0;
		};

		return {
			icons,
			showSettings,
			getShuffleIcon,
			foldouts,
			toggleFoldout,
			getItemShuffleTooltip,
			getSectionShuffleTooltip,
			isEmptyObject,
		};
	}
});

